
import Navbar from "@/components/Navbar/Navbar.vue";
import Footer from "@/components/Footer.vue";
import {computed, ref, watchEffect} from "vue";
import store from "@/store";
import i18n from "@/locales";
import {useRoute} from "vue-router";


export default {
  components: {Footer, Navbar},
  setup() {
    const route = useRoute();
    const cachedLang = ref(route.query.lang?.toString() ?? i18n.global.locale);
    watchEffect(() => {
      const currentLocale = route.query.lang?.toString() ?? i18n.global.locale;
      if (currentLocale !== cachedLang.value) {
        cachedLang.value = currentLocale;
        i18n.global.locale = currentLocale;
        console.log(cachedLang.value);
        store.commit("onAttemptLogin");
      }
    })

    const loading = computed(() => store.state.fetchingData);
    store.commit("onAttemptLogin");
    return {
      loading
    };
  }
}
